__turbopack_context__.v({
  "list": "CardLinks-module__2mBpga__list" + " " + "cds-t-body-small",
});
